import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isAfter, isValid, parseISO } from 'date-fns';
import { dateRangeValidator } from './date-range.validator';
import { timeRangeValidator } from './time-range.validator';

interface DateTimeRangeValidatorOptions {
  startDateName: string;

  endDateName: string;

  startTimeName: string;

  endTimeName: string;

  separateField: true;

  dateFormat?: string;

  timeFormat?: string;
}

//eslint-disable-next-line max-lines-per-function
export function dateTimeRangeValidator(
  options: Partial<DateTimeRangeValidatorOptions> = {},
): ValidatorFn {
  const input: DateTimeRangeValidatorOptions = {
    startDateName: 'startDate',
    endDateName: 'endDate',
    startTimeName: 'startTime',
    endTimeName: 'endTime',
    separateField: true,
    dateFormat: 'dd-MM-yyyy',
    ...options,
  };

  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) {
      throw new Error('This method can only be used on a formGroup.');
    }
    const dateError: ValidationErrors | null = dateRangeValidator({
      startDateName: input.startDateName,
      endDateName: input.endDateName,
      format: input.dateFormat,
    })(group);

    if (dateError) {
      return dateError;
    }

    const timeError: ValidationErrors | null = timeRangeValidator({
      startTimeName: input.startTimeName,
      endTimeName: input.endTimeName,
      format: input.timeFormat,
    })(group);
    if (timeError) {
      return timeError;
    }

    let errors: ValidationErrors | null = null;
    if (!isValid(group.value[input.startDateName]) || !isValid(group.value[input.endDateName])) {
      errors = { tsRangeDateNotSet: { value: group } };
    }

    if (!errors) {
      const start: string | Date = group.getRawValue()[input.startDateName];
      const end: string | Date = group.getRawValue()[input.endDateName];
      const startDate: Date = typeof start === 'string' ? parseISO(start) : start;
      const endDate: Date = typeof end === 'string' ? parseISO(end) : end;
      if (isAfter(startDate, endDate)) {
        errors = { tsRangeNotInRange: { value: group } };
      }
    }

    if (errors) {
      return errors;
    }

    return null;
  };
}
